import React from "react";
import useFormHandler from "../../../Validations/useFormHandler";
import Modal from "../../../Modal/Modal";
import FormFieldSet from "../../../FormFields/FormFieldSet";
import Button from "../../../Buttons/Button";

const ChangeInvoice = ({ onClose, isOpen }) => {
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      invoiceCategory: "",
    },
    {
      invoiceCategory: { type: "text", required: true },
    }
  );

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      console.log("form data:", formData);
      onClose();
    } else {
      console.log("error:", errors);
    }
  };
  return (
    <Modal
      title={"CHANGE INVOICE(S) CATEGORY"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-2xl"
    >
      <div>
        <div className="grid grid-cols-2 mt-4 gap-x-6 gap-y-4 max-w-3xl">
          <FormFieldSet
            type="select"
            title={"Invoice Category"}
            placeholder="Select Invoice Category"
            value={formData.invoiceCategory}
            onChange={(value) => handleChange("invoiceCategory", value)}
            error={errors.invoiceCategory}
          />
        </div>
        <div className="flex gap-3 justify-end my-8">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button title="Submit" onClick={() => handleSave()} />
        </div>
      </div>
    </Modal>
  );
};

export default ChangeInvoice;
